<template>
  <div v-if="filteredPropositions?.length > 0">
    <!-- presentation pdf -->
    <presentationGazVolt> </presentationGazVolt>

    <presentationGazSansAssocie v-if="role == 'Vendeur'" :infosCompteurPresentationProps="infosCompteurProps"
      :donnerCompteur="donnerCompteur" :donnerDesFournisseur="filteredPropositions" :numCompteur="numCompteur"
      :indexes="selectedData" :fournisseurActuelle="fournisseurActuelle" :societe="SocieteData"
      :id_historique_cotation="id_historique_cotation" />

    <presentationGaz v-else :infosCompteurPresentationProps="infosCompteurProps" :donnerCompteur="donnerCompteur"
      :donnerDesFournisseur="filteredPropositions" :numCompteur="numCompteur" :indexes="selectedData"
      :fournisseurActuelle="fournisseurActuelle" :societe="SocieteData"
      :id_historique_cotation="id_historique_cotation" />
    <!-- liste proposition par compteur -->
    <FilterPropositionsGaz :offers="{ data: dataForFilter }" @filter-applied="handleFilters" />
    <v-expansion-panels class="my-8" multiple v-model="expandedPanels">
      <v-expansion-panel class="px-6 py-4 mt-1" style="
          border: 1px solid rgb(199, 204, 216);
          box-shadow: 0px 4px 16px 0px rgb(199, 204, 216);
        " v-for="(company, indexPDL) in filteredPropositions" :key="company.name">
        <!-- header -->
        <v-expansion-panel-header style="padding: 0px">
          <div class="d-flex flex-row align-items-center">
            <h6 class="mb-0">Numéro de Compteur :&nbsp;&nbsp;</h6>
            <span class="MontSerrat-Bold" style="font-size: 15px; font-weight: bold; color: #02325c">{{
              company.NumCompteur }}</span>
          </div>
        </v-expansion-panel-header>

        <div v-if="filteredData(company.resultat?.result).length > 0">
          <v-divider class="mt-0"></v-divider>
          <!-- logo list -->
          <ul class="list-inline" style="padding: 0px">
            <li class="list-inline-item" v-for="(icon, index_v) in filteredData(company.resultat?.result)"
              :key="icon.name">
              <v-tooltip bottom style="z-index: 1000">
                <template v-slot:activator="{ on, attrs }">
                  <div style="
                      position: relative;
                      border: 2px solid #f04f4f;
                      border-radius: 10px;
                      padding: 10px;
                      background: #fff;
                    " class="td-table shadow" v-bind="attrs" v-on="on">
                    <v-img width="120px" height="auto" :src="getImageLogo(icon.logo)">
                    </v-img>
                    <v-icon style="position: absolute; top: 2px; right: 2px" color="#EED202">mdi-alert</v-icon>
                  </div>
                </template>
                <p style="color: white">{{ icon.message }}</p>
              </v-tooltip>
            </li>
          </ul>
        </div>

        <!-- propositions list -->
        <v-expansion-panel-content>
          <v-card class="my-8 pa-4"
            :style="{ 'border': compteurGaz.typeFournisseur == 'Actuelle' ? '2px solid #f49300' : 'none' }" style="
            
              box-shadow: 0px 4px 16px 0px rgb(199, 204, 216);
            " v-for="(compteurGaz, index) in company.resultat.result" :key="indexPDL + index" v-if="
              'message' in compteurGaz == false || 'offreIdResult' in compteurGaz == true
            ">
            <v-row outlined no-gutters class="header" style="background: #ffffff"
              v-if="'message' in compteurGaz == false">
              <!--<v-col cols="12" sm="1" md="1" lg="1" xl="1">
                    
                </v-col>-->
              <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-row class="d-flex flex-column flex-lg-row mt-4">
                  <v-checkbox style="position: absolute; top: 0; left: 0; z-index: 3" v-if="
                    company.resultat.actuelle == true &&
                    index == 0 &&
                    compteurGaz.typeFournisseur == 'Actuelle'
                  " class="ma-0 pa-0" input-value="true" :disabled="true"></v-checkbox>
                  <v-checkbox style="position: absolute; top: 0; left: 0; z-index: 3" v-else class="ma-0 pa-0"
                    v-model="selectedData[indexPDL]" @click.capture.stop :value="index"
                    :disabled="isSelectionOffreDisabled(index, indexPDL)"></v-checkbox>
                  <v-img :style="compteurGaz.logo == 'Engie_120X35.png' ? 'margin-left:50px' : ''
                    " overflow="hiden" max-width="238px" max-height="80px" contain
                    :src="getImageLogo(compteurGaz.logo)">
                  </v-img>
                  <div
                    class="mx-5 d-flex flex--row justify-start align-start align-lg-center justify-md-center align-items-center">
                    <div class="d-flex flex-column flex-sm-row" style="gap: 10px;" v-if="
                      compteurGaz.typeFournisseur != 'AuFrn' &&
                      compteurGaz.typeFournisseur != 'Actuelle'
                    ">
                      <p v-if="compteurGaz.grilleValidite"
                        class="d-flex flex-md-column flex-lg-row grey--text font-weight-light mb-0 ma-2 mx-xs-0">
                        Grille Validité:
                        <span style="color: #1a1a1a" class="text-body-1 font-weight-bold ml-2">{{
                          compteurGaz.grilleValidite
                        }}</span>
                      </p>
                      <p class="d-flex flex-md-column flex-lg-row grey--text font-weight-light mb-0 ma-2 mx-xs-0">
                        Début de contrat :
                        <span style="color: #1a1a1a" class="text-body-1 font-weight-bold ml-2">{{ compteurGaz.dateDebut
                        }}</span>
                      </p>
                      <p class="d-flex flex-md-column flex-lg-row grey--text font-weight-light mb-0 ma-2 mx-xs-0">
                        Fin de contrat :
                        <span style="color: #1a1a1a" class="text-body-1 font-weight-bold ml-2">{{ compteurGaz.dateFin
                        }}</span>
                      </p>
                    </div>
                    <div class="d-flex flex-column flex-sm-row" style="gap: 10px;">
                      <p
                        class="text-body-1 d-flex flex-md-column flex-lg-row grey--text font-weight-light mb-0 ma-2 mx-xs-0">
                        Durée de contrat :
                        <span style="color: #1a1a1a" class="text-body-1 font-weight-bold ml-2">{{ compteurGaz.DUREE }}
                          mois</span>
                      </p>
                      <p class="d-flex flex-md-column flex-lg-row grey--text font-weight-light mb-0 ma-2 mx-xs-0 ml-2">
                        Budget annuel :<span style="color: #1a1a1a" class="text-body-1 font-weight-bold ml-2">{{ "" +
                          compteurGaz.budget?.toLocaleString() }} €</span>
                      </p>
                      <p class="d-flex flex-md-column flex-lg-row grey--text font-weight-light mb-0 ma-2">
                        Offre :
                        <span v-if="
                          compteurGaz.typeFournisseur != 'AuFrn' &&
                          compteurGaz.typeFournisseur != 'Actuelle'
                        " style="color: #1a1a1a" class="text-body-1 font-weight-bold ml-2">
                          {{ compteurGaz.Offre }}
                        </span>
                        <span v-else style="color: #1a1a1a" class="text-body-1 font-weight-bold ml-2">
                          {{ compteurGaz.type }}
                        </span>
                      </p>
                      <p v-if="compteurGaz.dateSaisie"
                        class="text-body-1 d-flex flex-md-column flex-lg-row grey--text font-weight-light mb-0 ma-2 mx-xs-0">
                        Date de saisie de l'offre :
                        <span style="color: #1a1a1a" class="text-body-1 font-weight-bold ml-2">{{ compteurGaz.dateSaisie
                        }}</span>
                      </p>
                      <p v-if="showEconomie(company.resultat.result,compteurGaz) && compteurGaz.typeFournisseur != 'Actuelle'"
                        class="text-body-1 d-flex flex-md-column flex-lg-row grey--text font-weight-light mb-0 ma-2 mx-xs-0">
                        <span>Economie : </span>
                        <span
                          :class="getPercentageColorClass(company.resultat.result, compteurGaz)"
                          class="text-body-1 font-weight-bold ml-2">
                          {{ formatPercentage(calulatePercentage(company.resultat.result, compteurGaz)) }} en %/an
                        </span>
                      </p>
                      <p v-if="compteurGaz?.typeFournisseur != 'Actuelle' && compteurGaz?.['commission'] !== null && compteurGaz?.['commission'] !== undefined"
                        class="text-body-1 d-flex flex-md-column flex-lg-row grey--text font-weight-light mb-0 ma-2 mx-xs-0">
                        <span>Commission : </span>
                        <span style="color: #1a1a1a" class="text-body-1 font-weight-bold ml-2">{{
                          (compteurGaz?.['commission']
                          || 0)?.toLocaleString() }} €</span>
                      </p>
                    </div>
                  </div>
                  <div v-if="compteurGaz.typeFournisseur != 'AuFrn'">
                    <div v-if="compteurGaz.fournisseur == 'Ekwateur'" style="position: absolute; top: 0; right: 0">
                      <EkwateurContratGAZ :donner="compteurGaz" :numCompteur="company.NumCompteur"
                        :societe="company.resultat.dataSociete" :listCompteur="listCompteur" />
                    </div>
                    <div v-if="compteurGaz.fournisseur == 'GAZ DE BORDEAUX'"
                      style="position: absolute; top: 0; right: 0">
                      <GazDeBordeauxContrat :donner="compteurGaz" :numCompteur="company.NumCompteur"
                        :societe="company.resultat.dataSociete" :listCompteur="listCompteur"
                        :donnerCompteurs="filteredGazResults" />
                    </div>
                    <div v-if="compteurGaz.fournisseur == 'Endesa'" style="position: absolute; top: 0; right: 0"
                      class="mr-8 mt-1 mb-1" align="right">
                      <v-btn @click="downlmoadFileEndesa(compteurGaz.offreId)" depressed
                        class="ma-auto text-capitalize text-white" :color="$colors[0]">
                        <v-icon :color="$colors[0]">mdi-text-box-edit</v-icon>
                      </v-btn>
                    </div>
                  </div>
                </v-row>
              </v-col>
              <!-- <div
                v-if="compteurGaz.fournisseur == 'Engie'"
                style="position: absolute; top: 0; right: 0"
                class="mt-1 mb-1"
                align="right"
              >
                <engieProGaz
                  :donner="compteurGaz"
                  :numCompteur="company.NumCompteur"
                  :societe="company.resultat.dataSociete"
                />
              </div> -->


              <v-col cols="12" sm="12" md="12" lg="12" xl="12">
                <v-divider class="mb-3"></v-divider>
              </v-col>
              <!-- infos -->
              <v-col cols="12" sm="4" md="3" lg="2" xl="2" align="center" justify="center">
                <p class="d-flex flex-column text-body-1 ma-0">
                  <span class="text-body-1 grey--text font-weight-light">Prix de la molécule</span>
                  <span style="color: #1a1a1a" class="text-body-1 font-weight-bold mr-1">{{ "" +
                    compteurGaz.prixMolucule?.toLocaleString() }}€/MWh</span>
                </p>
              </v-col>
              <v-col cols="12" sm="4" md="3" lg="2" xl="2" align="center" justify="center">
                <p class="d-flex flex-column text-body-1 ma-0">
                  <span class="text-body-1 grey--text font-weight-light">Terme Variable</span>
                  <span style="color: #1a1a1a" class="text-body-1 font-weight-bold mr-1">{{ "" +
                    compteurGaz.ARTD?.toLocaleString() }}€/MWh</span>
                </p>
              </v-col>
              <v-col cols="12" sm="4" md="3" lg="2" xl="2" align="center" justify="center">
                <p class="d-flex flex-column text-body-1 ma-0">
                  <span class="text-body-1 grey--text font-weight-light">Abonnement annuel</span>
                  <span style="color: #1a1a1a" class="text-body-1 font-weight-bold mr-1">{{ "" +
                    compteurGaz.ABO?.toLocaleString() }}€</span>
                </p>
              </v-col>
              <v-col cols="12" sm="4" md="3" lg="2" xl="2" align="center" justify="center">
                <p class="d-flex flex-column text-body-1 ma-0">
                  <span class="text-body-1 grey--text font-weight-light">CTA</span>
                  <span style="color: #1a1a1a" class="text-body-1 font-weight-bold mr-1">{{ "" +
                    compteurGaz.CTA?.toLocaleString() }}€/an</span>
                </p>
              </v-col>
              <v-col cols="12" sm="4" md="3" lg="2" xl="2" align="center" justify="center">
                <p class="d-flex flex-column text-body-1 ma-0">
                  <span class="text-body-1 grey--text font-weight-light">TICGN</span>
                  <span style="color: #1a1a1a" class="text-body-1 font-weight-bold mr-1">{{ "" +
                    compteurGaz.TICGN?.toLocaleString() + "€/MWh" }}</span>
                </p>
              </v-col>
              <v-col cols="12" sm="4" md="3" lg="2" xl="2" align="center" justify="center">
                <p class="d-flex flex-column text-body-1 ma-0">
                  <span class="text-body-1 grey--text font-weight-light">CEE</span>
                  <span style="color: #1a1a1a" class="text-body-1 font-weight-bold mr-1"
                    v-if="compteurGaz.cee == 'NON SOUMIS'">NON SOUMIS</span>
                  <span v-else style="color: #1a1a1a" class="text-body-1 font-weight-bold mr-1">{{ "" +
                    compteurGaz.cee?.toLocaleString() }}€/MWh</span>
                </p>
              </v-col>
            </v-row>
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>
<script>
import GazDeBordeauxContrat from "../../../views/edition-contrat/GazDeBordeaux.vue";
import EkwateurContratGAZ from "../../../views/edition-contrat/EkwateurGaz.vue";
import engieProGaz from "../../../views/edition-contrat/engieProGaz.vue";
import presentationGaz from "../../../views/presentation/NewElecCalcul/newPresentationGaz.vue";
import presentationGazVolt from "../../../views/presentation/NewElecCalcul/presentationGazVolt.vue";
import presentationGazSansAssocie from "../../../views/presentation/NewElecCalcul/newPresentationGazSansAssocie.vue";

import axios from "axios";
import download from "downloadjs";
import moment from "moment";
import { degrees, PDFDocument, rgb, StandardFonts, layoutMultilineText } from "pdf-lib";
import FilterPropositionsGaz from "./filterPropositionsGaz.vue";

export default {
  name: "ListePropositionsGaz",
  props: {
    infosCompteurProps: null,
    Propositions: {
      type: Array,
      default: () => []
    },
    SocieteData: [],
    numCompteur: null,
    typeCompteur: null,
    panel: [],
    fournisseurActuelle: null,
    selected: [],
    listCompteur: [],
    donnerCompteur: {},
    id_historique_cotation: null,
  },
  components: {
    FilterPropositionsGaz, // Add the filter component
    presentationGazVolt,
    presentationGaz,
    EkwateurContratGAZ,
    GazDeBordeauxContrat,
    engieProGaz,
    presentationGazSansAssocie
  },
  data() {
    return {
      selectedData: [],
      actuelleExist: false,
      dialog: false,
      loading: false,
      error: false,
      codePremio: "",
      role: localStorage.getItem("typeUser"),
      expandedPanels: [0],
      activeFilters: null,
      filteredPropositions: [],
      dataForFilter: {} // For formatting data for the filter component
    };
  },
  mounted() {
    this.role = localStorage.getItem("typeUser");
    // Initialize selected data
    this.initializeSelectedData();

    // Initialize filtered propositions
    this.filteredPropositions = [...this.Propositions];

    // Prepare data for filter component
    this.prepareDataForFilter();
  },
  computed: {
    filteredGazResults() {
      return this.filteredPropositions.map(company => {
        const filteredResult = company.resultat.result.filter(compteurGaz =>
          !('message' in compteurGaz) || 'offreIdResult' in compteurGaz
        );
        return {
          NumCompteur: company.NumCompteur,
          resultat: {
            ...company.resultat,
            result: filteredResult
          }
        };
      });
    }
  },
  watch: {
    Propositions: {
      handler(newValue) {
        // Reset selected data
        this.selectedData = [];
        this.initializeSelectedData();

        // Reset filtered propositions
        this.filteredPropositions = [...newValue];

        // Expand only the first panel on list change
        this.expandedPanels = [0];

        // Update data for filters
        this.prepareDataForFilter();
      },
      deep: true,
      immediate: true
    }
  },

  methods: {
    initializeSelectedData() {
      for (let i = 0; i < this.Propositions?.length; i++) {
        this.selectedData.splice(i, 0, []);
        if (this.Propositions[i].resultat.result.length > 0) {
          // Check if an "Actuelle" offer exists
          for (let j = 0; j < this.Propositions[i].resultat.result.length; j++)
            if (this.Propositions[i].resultat.result[j].typeFournisseur == "Actuelle") {
              this.selectedData[i].push(0);
              this.actuelleExist = true;
            }
        }
      }
    },
    showEconomie(compteurOffers, offer) {
      return compteurOffers.some(o => o.typeFournisseur == 'Actuelle') && offer.typeFournisseur != 'Actuelle';
    },

    calulatePercentage(compteurOffers, offer) {
      let actuelle = compteurOffers.find(o => o.typeFournisseur == 'Actuelle');
      let percentage = 0;
      let currentTotal = actuelle?.budget || 0;
      let offerTotal = offer?.budget || 0;
      
      if (currentTotal != 0) {
        percentage = (offerTotal - currentTotal) / currentTotal * 100;
      }
      
      // Return the raw number for calculations, don't format here
      return percentage;
    },
    // Format percentage for display
    formatPercentage(percentage) {
      return new Intl.NumberFormat("fr-FR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
      }).format(percentage);
    },

    // Get color class based on percentage value
    getPercentageColorClass(compteurOffers, offer) {
      const percentage = this.calulatePercentage(compteurOffers, offer);
      
      // Handle the formatted string case - extract the number
      let num = percentage;
      if (typeof percentage === 'string') {
        // Remove formatting and parse
        const cleaned = percentage.replace(/[^\d.-]/g, '');
        num = parseFloat(cleaned);
      }
      
      // Only return grey for truly invalid numbers
      if (typeof num !== 'number' || isNaN(num) || !isFinite(num)) {
        return 'grey--text';
      }
      
      // Simple rule: negative = green, zero or positive = red
      return num < 0 ? 'green--text' : 'red--text';
    },

    // Format data for the filter component
    prepareDataForFilter() {
      // Create a data object in the format expected by the filter component
      const formattedData = {};

      this.Propositions.forEach(comp => {
        formattedData[comp.NumCompteur] = {
          result: comp.resultat.result,
          numCompteur: comp.NumCompteur,
          dataSociete: comp.resultat.dataSociete || {},
          actuelle: comp.resultat.actuelle || false,
          typeCompteur: comp.resultat.typeCompteur || '',
          donnerCompteur: comp.resultat.donnerCompteur || {}
        };
      });

      this.dataForFilter = formattedData;
    },

    // Handle filter events from GazOffersFilter component
    handleFilters(filters) {
      this.activeFilters = filters;

      // Initialize filtered list with a deep copy of propositions
      let filtered = JSON.parse(JSON.stringify(this.Propositions));

      // Loop through each compteur key
      filtered = filtered.map(company => {
        const companyCopy = { ...company };

        // Filter the result array
        if (companyCopy.resultat && companyCopy.resultat.result) {
          // Apply the filtering
          companyCopy.resultat.result = this.filterResultsByActiveFilters(companyCopy.resultat.result);

          // Apply sorting if selected - only apply one sort at a time with budget taking precedence
          if (this.activeFilters.budgetSort) {
            companyCopy.resultat.result = this.sortResultsByBudget(companyCopy.resultat.result, this.activeFilters.budgetSort);
          } else if (this.activeFilters.commissionSort) {
            companyCopy.resultat.result = this.sortResultsByCommission(companyCopy.resultat.result, this.activeFilters.commissionSort);
          }
        }

        return companyCopy;
      });

      // Update filtered propositions
      this.filteredPropositions = filtered;
    },

    // Filter results based on active filters
    filterResultsByActiveFilters(results) {
      if (!this.activeFilters || !results || !Array.isArray(results)) {
        return results;
      }

      return results.filter(offer => {
        // Keep error messages intact
        if (offer.status === 'error' || offer.status === 'enattend') {
          return true;
        }

        // Always show "Actuelle" offers for comparison
        if (offer.typeFournisseur === 'Actuelle') {
          return true;
        }

        // Check if offer is valid
        if (!offer || !offer.fournisseur) {
          return false;
        }

        // Filter by suppliers
        if (this.activeFilters.suppliers && this.activeFilters.suppliers.length > 0) {
          if (!offer.fournisseur || !this.activeFilters.suppliers.includes(offer.fournisseur)) {
            return false;
          }
        }

        // Filter by durations
        if (this.activeFilters.durations && this.activeFilters.durations.length > 0) {
          if (!offer.DUREE || !this.activeFilters.durations.includes(parseInt(offer.DUREE))) {
            return false;
          }
        }

        // Filter by offer types
        if (this.activeFilters.offerTypes && this.activeFilters.offerTypes.length > 0) {
          const offerType = offer.type || offer.Offre;
          if (!offerType || !this.activeFilters.offerTypes.includes(offerType)) {
            return false;
          }
        }

        // Filter by meter types
        if (this.activeFilters.meterTypes && this.activeFilters.meterTypes.length > 0) {
          if (!offer.typeCompteur || !this.activeFilters.meterTypes.includes(offer.typeCompteur)) {
            return false;
          }
        }

        // Filter by profiles
        if (this.activeFilters.profiles && this.activeFilters.profiles.length > 0) {
          if (!offer.profilCompteur || !this.activeFilters.profiles.includes(offer.profilCompteur)) {
            return false;
          }
        }

        // Filter by contract start date
        if (this.activeFilters.startDate) {
          const filterStartDate = new Date(this.activeFilters.startDate);
          if (offer.dateDebut) {
            const [day, month, year] = offer.dateDebut.split('/');
            const offerStartDate = new Date(`${year}-${month}-${day}`);

            if (offerStartDate < filterStartDate) {
              return false;
            }
          }
        }

        // Filter by contract end date
        if (this.activeFilters.endDate) {
          const filterEndDate = new Date(this.activeFilters.endDate);
          if (offer.dateFin) {
            const [day, month, year] = offer.dateFin.split('/');
            const offerEndDate = new Date(`${year}-${month}-${day}`);

            if (offerEndDate > filterEndDate) {
              return false;
            }
          }
        }

        // If passed all filters, include the offer
        return true;
      });
    },
    sortResultsByBudget(results, sortDirection) {
      if (!results || !Array.isArray(results)) {
        return results;
      }

      // Filter out items without budget or error messages
      const sortableResults = results.filter(item =>
        item.budget && typeof item.budget === 'number' &&
        item.status !== 'error' && item.status !== 'enattend'
      );

      // Keep error messages separate
      const errorMessages = results.filter(item =>
        !item.budget || typeof item.budget !== 'number' ||
        item.status === 'error' || item.status === 'enattend'
      );

      // Sort the results with budget
      sortableResults.sort((a, b) => {
        if (sortDirection === 'asc') {
          return a.budget - b.budget;
        } else {
          return b.budget - a.budget;
        }
      });

      // Return sorted items with error messages at the end
      return [...sortableResults, ...errorMessages];
    },

    // Sort results by commission
    sortResultsByCommission(results, sortDirection) {
      if (!results || !Array.isArray(results)) {
        return results;
      }

      // Filter out items without commission or error messages
      const sortableResults = results.filter(item =>
        item.commission !== undefined &&
        item.status !== 'error' && item.status !== 'enattend'
      );

      // Keep error messages separate
      const errorMessages = results.filter(item =>
        item.commission === undefined ||
        item.status === 'error' || item.status === 'enattend'
      );

      // Sort the results with commission
      sortableResults.sort((a, b) => {
        if (sortDirection === 'asc') {
          return a.commission - b.commission;
        } else {
          return b.commission - a.commission;
        }
      });

      // Return sorted items with error messages at the end
      return [...sortableResults, ...errorMessages];
    },

    // Your existing methods
    isSelectionOffreDisabled(index, indexPDL) {
      // Check if "Actuelle" exists for this specific PDL
      const hasActuelle = this.filteredPropositions[indexPDL]?.resultat.result.some(
        result => result.typeFournisseur === "Actuelle"
      );

      const maxAllowed = hasActuelle ? 4 : 3;
      const isNotSelected = this.selectedData[indexPDL].indexOf(index) === -1;
      return isNotSelected && this.selectedData[indexPDL].length >= maxAllowed;
    },

    async downlmoadFileEndesa(offreId) {
      // Your existing method
      await axios({
        url: process.env.VUE_APP_URL_API_CLIENT + "downloadFilesEndesa/",
        method: "POST",
        data: { offreId: offreId, token: this.getToken("token") },
      })
        .then(async (res) => {
          // Your existing logic
        })
        .catch((err) => {
          console.log(err);
        });
    },

    filteredData(dataArray) {
      const filtered = [];
      const seen = new Set();
      dataArray.forEach((item) => {
        // Check if logo is the same and status is 'enattend'
        if (
          item.hasOwnProperty("message") &&
          item.hasOwnProperty("status") &&
          (item.status == "error" || item.status == "enattend") &&
          !seen.has(item.logo)
        ) {
          filtered.push(item);
          seen.add(item.logo);
        }
      });
      return filtered;
    },

    getImageLogo(logo) {
      return require("@/assets/logoParticulier/" + logo);
    },
  },
};
</script>

<style scoped>
.v-expansion-panel::before {
  box-shadow: none;
}

.v-expansion-panel::after {
  border: none;
}

.v-expansion-panel-content__wrap {
  padding: 0px !important;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0px !important;
}

@media only screen and (max-width: 600px) {
  .marginBtnPresentation {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
}

@media only screen and (max-width: 350px) {
  ::v-deep .v-expansion-panel-header {
    padding: 15px !important;
  }

  ::v-deep .responsiveSpan {
    font-size: 0.8rem !important;
  }
}

.v-expansion-panel::before {
  box-shadow: none;
}

.v-expansion-panel::after {
  border: none;
}

.v-expansion-panel-content__wrap {
  padding: 0px !important;
}

::v-deep .v-expansion-panel-content__wrap {
  padding: 0px !important;
}

@media only screen and (max-width: 600px) {
  .marginBtnPresentation {
    padding-right: 0px !important;
    padding-left: 0px !important;
  }
}

@media only screen and (max-width: 350px) {
  ::v-deep .v-expansion-panel-header {
    padding: 15px !important;
  }

  ::v-deep .responsiveSpan {
    font-size: 0.8rem !important;
  }
}
</style>
